module.exports = __webpack_public_path__ + "static/media/projectsImage13.a1709db3.jpg";